import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Divider,
  FormHelperText,
  Grid,
  Tooltip,
} from "@mui/material";
import { ExportToCsv } from "export-to-csv";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    wordWrap: "break-word",
  },
  linkTitle: {
    color: theme.palette.primary.copy,
  },
  linkValue: {
    color: theme.palette.primary.dark,
    cursor: "pointer",
    overflowX: "auto",
    whiteSpace: "nowrap",
    paddingBottom: "5px",
    "&:hover": {
      color: theme.palette.primary.light,
    },
  },
}));

const csvOptions = {
  filename: "Prefiltered Links",
  fieldSeparator: ",",
  quoteStrings: '"',
  decimalSeparator: ".",
  showLabels: true,
  showTitle: true,
  title: "Prefiltered Links",
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
};

const csvExporter = new ExportToCsv(csvOptions);

export default function PrefilteredLinksModal({ openModal, links }) {
  const [toolTipTitle, setToolTipTitle] = useState("Click to Copy");
  const [linkValue, setLinkValue] = useState("");

  function resetValues(newLinkValue) {
    // We are hovering on the same link that was just copied
    if (newLinkValue === linkValue) {
      setToolTipTitle("Copied!");
    } else {
      setToolTipTitle("Click to Copy");
    }
  }

  function copyLink(link) {
    setLinkValue(link);
    setToolTipTitle("Copied!");
    navigator.clipboard.writeText(link);
  }

  function exportLinks() {
    // if there are selected filters (item3), build out a readable string for them.
    const csvInput = JSON.parse(JSON.stringify(links));

    csvInput.forEach((link) => {
      let filters = "";
      link.item3?.forEach((filter) => {
        filters += filter.name + ": " + filter.value + " | ";
      });
      link.item3 = filters === "" ? "N/A" : filters;
    });

    csvExporter.generateCsv(csvInput);
  }

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Prefiltered Links
            </FormHelperText>
            <Grid container spacing={1}>
              {links.map((link, index) => (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    alignItems="center"
                    className={classes.linkTitle}
                  >
                    <span>{link.item1}:</span>
                  </Grid>
                  <Grid item xs={12} sm={12} container>
                    <Tooltip title={toolTipTitle} placement="top">
                      <span
                        onMouseEnter={() => resetValues(link.item2)}
                        onClick={() => copyLink(link.item2)}
                        className={classes.linkValue}
                      >
                        {link.item2}
                      </span>
                    </Tooltip>
                  </Grid>
                  {link.item3 != null ? (
                    link.item3.length > 0 ? (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <span>
                            <b>Selected Filters:</b> <br></br>
                          </span>
                          <Divider></Divider>
                        </Grid>
                        {link.item3.map((selectedField, index) => (
                          <Grid item xs={12} sm={12}>
                            <span>
                              {selectedField.name}: {selectedField.value}
                              <br></br>
                            </span>
                            <Divider></Divider>
                          </Grid>
                        ))}
                      </Grid>
                    ) : null
                  ) : null}
                  {link.item3 != null ? (
                    link.item3.length > 0 ? null : (
                      <Grid item xs={12} sm={12}>
                        <Divider />
                      </Grid>
                    )
                  ) : (
                    <Grid item xs={12} sm={12}>
                      <Divider />
                    </Grid>
                  )}
                </>
              ))}
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ marginTop: "20px", marginRight: "8px" }}
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => exportLinks()}
                >
                  Export to CSV
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
